import React, { ReactNode, TextareaHTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InformationTag from '../InfoTag/InfoTag';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  itemNumber?: number;
  register: UseFormRegisterReturn;
  labelName?: ReactNode;
  fieldName: string | "field";
  infoTagMessage?: string | " ";
  errors?: Record<string, any>; 
}

const TextAreaField: React.FC<TextareaProps> = ({ register, labelName, fieldName, errors,infoTagMessage, itemNumber, ...rest }) => {
  return (
    <div className="mb-8">
      <div className="flex">
        { itemNumber !== 0 &&                 
                <div className="flex-none w-5 text-sm">{itemNumber}.</div>                
        }        
        <div className="text-sm grid grid-cols-2"><div>{labelName}</div> <div className="ml-2"><InformationTag message={infoTagMessage} /></div></div>
      </div>
      <div className="flex">
        { itemNumber !== 0 && 
          <div className="flex-none w-5"></div>
        } 
        <div className="grow mt-3">
            <textarea
              rows={4}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
              {...rest}
              {...register} // This spreads the register function correctly
            ></textarea>
            {errors && errors[fieldName] && (
              <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
            )}
         </div>
      </div>
    </div>
  );
};

export default TextAreaField;